import { useTranslation } from "react-i18next";
import { Spinner } from "reactstrap";

import { PageLoaderProps } from "@models/utils/loader.model";

const Loader = (props: PageLoaderProps) => {
  const { t } = useTranslation();

  const {
    isLoading = false,
    message = t("loading"),
    overlayOnly = false,
  } = props;

  return (
    <div
      className={`fg-page-loader${!isLoading ? " d-none" : ""}`}
      data-testid="loader-component"
    >
      <div className="text-center">
        {!overlayOnly && (
          <>
            <Spinner color="primary" data-testid="spinner"></Spinner>
            <div className="st-text st-bg-coffee st-text-white py-1 px-3 rounded">
              {message}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Loader;
